export default __webpack_public_path__ + "static/media/4_forceUse.4d55e351.csv";